// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { DispatchType } from "../../global/types/redux";
import type { ErrorsType, UserFormType } from "../types/UserFormType";
import { PasswordStrengthBox, checkPswStrength } from "../../global/components/PasswordStrength";
import { SingleTextField, SubmitButton, SingleCheckBox, CompleteMessage } from "imagus-components";
import { setErrorMsg, checkEmail, checkPassword, ErrosDisplay } from "../containers/ErrosDisplay";
import Terms from "../components/Terms";
import { CopyRight } from "../../global/components/CopyRight";
import { userSignup } from "../../account/actions/profileActions";
import BlueLogoImage from "../../../images/VixVizion.svg";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import PersonIcon from "@material-ui/icons/Person";
import EmailIcon from "@material-ui/icons/Email";
import StoreMallDirectoryIcon from "@material-ui/icons/StoreMallDirectory";

const DEBOUNCETIME = 500;

const initialUserform: UserFormType = {
  errors: {},
  loading: false,
  email: "",
  password: "",
  password2: "",
  firstname: "",
  companyname: "",
  lastname: "",
  termsagreed: false,
  completed: false,
  passwordstrength: {
    uppercase: false,
    lowercase: false,
    number: false,
    length: false
  },
  termsOpen: false
};

class SignupForm extends Component<*, UserFormType> {
  timeout: number;
  constructor(props) {
    super(props);
    this.signup = this.signup.bind(this);
    this.state = initialUserform;
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ termsOpen: status });
  }

  CheckTerms = (): * => {
    this.setState({ termsagreed: true });
    this.setState({ errors: setErrorMsg(this.state.errors, "agree_check", "", true) });
  }

  handleChange = (e: Event & { currentTarget: HTMLInputElement }): * => {
    const errors = this.state.errors;
    const name = e.currentTarget.name;
    const value = e.currentTarget.value;

    if (name === "termsagreed") {
      this.setState({ termsagreed: !this.state.termsagreed }, () => {
        if (!this.state.termsagreed) {
          this.setState({ errors: setErrorMsg(errors, "agree_check", "Please confirm you have read our Terms and Conditions.") });
        }
        else {
          this.setState({ errors: setErrorMsg(errors, "agree_check", "", true) });
        }
      });
    }
    else {
      this.setState({
        [name]: value
      });

      //password strength check
      if (name === "password") {
        this.setState({
          passwordstrength: checkPswStrength(this.state.passwordstrength, value)
        });
      }

      if (name === "password" || name === "password2") {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function(){
          this.setState({ errors: checkPassword(errors, this.state.password, this.state.password2) });
        }.bind(this), DEBOUNCETIME);
      }

      if (name === "email") {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function(val: string){
          this.setState({ errors: checkEmail(errors, val) });
        }.bind(this, value), DEBOUNCETIME);
      }
    }
  }

  signup = async (e: Event): * => {
    const errors = this.state.errors;
    e.preventDefault();
    e.stopPropagation();

    if (!this.state.termsagreed) {
      this.setState({ errors: setErrorMsg(errors, "agree_check", "Please confirm you have read our Terms and Conditions.") });
    }

    if (Object.keys(errors).length === 0 && !Object.values(this.state.passwordstrength).includes(false)) {
      this.setState((): * => ({ "loading": true }));
      this.props.actions.userSignup(
        this.state.email.trim(),
        this.state.password.trim(),
        this.state.firstname.trim(),
        this.state.lastname.trim(),
        this.state.companyname.trim(),
        (): * => {
          this.setState({ completed: true });
          this.setState((): * => ({ "loading": false }));
        },
        (errors: ErrorsType): * => {
          this.setState((state: UserFormType): * => ({
            errors: errors
          }));
          this.setState((): * => ({ "loading": false }));
        }
      );
    }
  }

  render(): React$Element<*> {
    const loading = this.state.loading;
    const errors = this.state.errors;

    if (this.state.completed) {
      return (
        <Grid container spacing={24}>
          <Grid item xs={1}></Grid>
          <Grid item xs={10}>
            <CompleteMessage
              title="Sign Up Complete"
              content="Thank you<br>
                      Your account has been created<br>
                      and a Vertification Email has been sent.<br>
                      Click on the link incluedd in the Email to activate your account/licence."
              onClick={null}
              isPageCenter
            />
          </Grid>
        </Grid>
      );
    }
    else {
      return (
        <div className="wrapper">
          <img src={BlueLogoImage} className="form-logo" style={{ float: "left" }} />
          <div style={{ clear: "both" }}></div>

          <div className="form-text">
            <Typography variant="h5" className="green-title" style={{ marginBottom: "30px" }}>Sign Up for Imagus account</Typography>
          </div>
          <form onSubmit={(!loading && this.signup) || undefined}>
            <Grid container spacing={8}>
              <Grid item xs={1} className="icon-block">
                <PersonIcon className="grey-icon medium-icon" />
              </Grid>
              <Grid item xs={11} md={5}>
                <SingleTextField
                  isRequired={true}
                  label="First Name"
                  name="firstname"
                  value={this.state.firstname}
                  onChange={this.handleChange}
                  inpuType="text"
                />
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={11} md={5}>
                <SingleTextField
                  isRequired={true}
                  label="Last Name"
                  name="lastname"
                  value={this.state.lastname}
                  onChange={this.handleChange}
                  inpuType="text"
                />
              </Grid>
              <Grid item xs={1} className="icon-block">
                <LockOutlinedIcon className="grey-icon medium-icon" />
              </Grid>
              <Grid item xs={11} md={5}>
                <SingleTextField
                  isRequired={true}
                  label="New Password"
                  name="password"
                  value={this.state.password}
                  onChange={this.handleChange}
                  inpuType="password"
                />
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={11} md={5}>
                <SingleTextField
                  isRequired={true}
                  label="Confirm Password"
                  name="password2"
                  value={this.state.password2}
                  onChange={this.handleChange}
                  inpuType="password"
                  isInvalid={errors.password !== undefined}
                />
              </Grid>
              <Grid item xs={12}>
                <PasswordStrengthBox
                  passwordstrength={this.state.passwordstrength}
                  password={this.state.password}
                />
              </Grid>
              <Grid item xs={1} className="icon-block">
                <EmailIcon className="grey-icon medium-icon" />
              </Grid>
              <Grid item xs={11}>
                <SingleTextField
                  isRequired={true}
                  label="Email Address"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  inpuType="text"
                  isInvalid={errors.email !== undefined}
                />
              </Grid>
              <Grid item xs={1} className="icon-block">
                <StoreMallDirectoryIcon className="grey-icon medium-icon" />
              </Grid>
              <Grid item xs={11}>
                <SingleTextField
                  isRequired={true}
                  label="Company Name"
                  name="companyname"
                  value={this.state.companyname}
                  onChange={this.handleChange}
                  inpuType="text"
                />
              </Grid>
              <Grid item xs={1} style={{ marginTop: "20px" }}>
                <SingleCheckBox
                  name="termsagreed"
                  value={this.state.termsagreed}
                  onChange={this.handleChange}
                  label=""
                  isInvalid={errors.agree_check !== undefined}
                />
              </Grid>
              <Grid item xs={11} style={{ marginTop: "20px" }}>
                <Typography variant="subtitle1" className="green-title" style={{ lineHeight: "50px" }}>
                  <span className="form-hint">{"I " + (this.state.termsagreed ? "agreed" : "agree") + " to the licence "}</span>
                  <span onClick={(): Function => this.switchModalStatus(true)} className="form-link-green">Terms and Conditions.</span>
                  <Terms CheckTerms={this.CheckTerms} open={this.state.termsOpen} handleModalStatus={this.switchModalStatus} />
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ErrosDisplay errors={errors} form="signup" />
              </Grid>
              <Grid item xs={12} style={{ marginBottom: "30px" }}>
                <div className="form-btn-block">
                  <SubmitButton
                    loading={loading}
                    title="Sign Me Up"
                    fullWidth
                    isMainButton
                    disabled={Object.keys(errors).length > 0 || Object.values(this.state.passwordstrength).includes(false)}
                  />
                </div>
              </Grid>
              <Grid item xs={12} style={{ marginBottom: "2%" }}>
                <Divider light />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" className="green-title form-text">
                  <span className="form-hint">Already has an account or Licence?</span>
                  <span onClick={() => this.props.changePage()} className="form-link-green">Log In Here</span>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1" className="green-title form-text fixed-bottom">
                  <span className="">{CopyRight}</span>
                </Typography>
              </Grid>
            </Grid>
          </form>
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ userSignup }, dispatch)
});

export default connect(null, mapDispatchToProps)(SignupForm);
